import { Message } from 'src/types';
import ShareQuestion from './ShareQuestion';

const ShareEntireChat = ({ storeMessages }: { storeMessages: Message[] }) => {
	return (
		<div className="share-chat-list">
			{storeMessages.map((message, index) => {
				return (
					message.from !== 'user' && <ShareQuestion key={message.id} userAnswer={storeMessages[index - 1].text} botReply={message.text} />
				);
			})}
		</div>
	);
};

export default ShareEntireChat;
